import {api, RequestParam} from "@/shared/api";
import {FormUtil} from "@/shared/forms/formUtil";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Button from "@/shared/utils/button";
import {DOMUtil} from "@/shared/utils/dom";
import {formatTime, parseISOZonedDateTime} from "@/shared/utils/datefunctions";
import {WorkingTimeType} from "@/shared/timr";

export interface SwitchWorkingTimeTypeDialogConfig {
	container: JQuery;
	workingTimeTypes: WorkingTimeType[];
	breakTimeTypes: WorkingTimeType[];
}

export class SwitchWorkingTimeTypeDialog {

	public static EVENT_WORKING_TIME_TYPE_SWITCHED = "workingTimeTypeSwitched";
	public static EVENT_CLOSED = "closed";

	private dialog: BootstrapModal.Modal;
	private params: RequestParam[];

	constructor(public config: SwitchWorkingTimeTypeDialogConfig) {
		this.init();
	}

	public show(params: RequestParam[], mode: "switch" | "pause" | "resume" = "switch") {
		this.params = params;

		const endDateTimeString = params.filter((e) => e.name === "end")[0].value as string;
		const endTime = formatTime(parseISOZonedDateTime(endDateTimeString));
		this.dialog.setTitle(messages.withArguments(`switchWorkingTimeTypeDialog.${mode}.title`, endTime));
		DOMUtil.fillWorkingTimeTypeSelect(this.config.container.find("#workingTimeSwitchWorkingTimeTypeId"), mode === "pause" ? this.config.breakTimeTypes : this.config.workingTimeTypes, false);
		this.dialog.show();
		this.updateSwitchButton(mode === "pause");
	}

	public isVisible(): boolean {
		return this.config.container.is(":visible");
	}

	private init() {
		this.dialog = new BootstrapModal.Modal({
			title: "switchWorkingTimeTypeDialog.switch.title",
			message: this.config.container,
			buttons: [{
				text: "dialog.switch",
				action: () => {
					this.setDialogLoadingState(true);
					this.switchWorkingTimeType(this.config.container.find("#workingTimeSwitchWorkingTimeTypeId").val() as number);
				},
				css: "btn-primary"
			}, {
				text: "dialog.cancel",
				css: "cancelButton btn-default"
			}],
			onClose: () => {
				$(this).triggerHandler(SwitchWorkingTimeTypeDialog.EVENT_CLOSED);
				this.setDialogLoadingState(false);
			}
		});
	}

	private setDialogLoadingState(setLoading: boolean) {
		$("#workingTimeSwitchWorkingTimeTypeId").prop("disabled", setLoading);
		this.dialog.getButtons("cancelButton").prop("disabled", setLoading);
		if (setLoading) {
			Button.setLoading(this.dialog.getButtons("btn-primary"));
		} else {
			Button.resetLoading(this.dialog.getButtons("btn-primary"));
		}
	}

	private switchWorkingTimeType(workingTimeTypeId: number) {
		if (this.params && workingTimeTypeId) {
			this.params.push({name: "newWorkingTimeTypeId", value: workingTimeTypeId});
			this.params.push({name: "timestamp", value: new Date().getTime()});

			api("recording/switchWorkingTimeRecording.json")
				.post(this.params)
				.done((data) => {
					FormUtil.removeAllFeedback($("#workingTimeStatusForm"));
					$(this).triggerHandler(SwitchWorkingTimeTypeDialog.EVENT_WORKING_TIME_TYPE_SWITCHED, [data]);
					this.dialog.close();
				})
				.fail(() => this.setDialogLoadingState(false));
		}
	}

	private updateSwitchButton(pause: boolean) {
		this.dialog.getButtons("btn-primary").text(messages[pause ? "dialog.pause" : "dialog.switch"]);
	}
}
